import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { PartSharpEdges, SharpEdgesService, parsePartSharpEdges } from '@infinitform/platform-core';
import { CLOUD_PLATFORM_CONFIG } from '../config';

@Injectable()
export class CloudSharpEdgesService implements SharpEdgesService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(CLOUD_PLATFORM_CONFIG);

  async load(projectId: string, partId: string): Promise<PartSharpEdges | null> {
    try {
      // The backend hands out a signed URL; the file itself comes from S3,
      // which answers 404 for a part imported before it was measured.
      const url = await lastValueFrom(
        this.http.get(`${this.config.apiBaseUrl}/project/${projectId}/parts/${encodeURIComponent(partId)}/sharpedges`, {
          responseType: 'text',
        })
      );
      return parsePartSharpEdges(await lastValueFrom(this.http.get<unknown>(url)), partId);
    } catch {
      return null;
    }
  }
}
